module.exports = __webpack_public_path__ + "44a0c83b78ba6fe731b772484c75b4f8.pdf";